import MarketStrategies from ".";
import { getCountryCode } from "../../helpers/getCountryCode";

const useMarketStrategy = () => {
  return MarketStrategies[getCountryCode()];
};

export default useMarketStrategy;
